import { Col, Form, Input, Row, Select, Table, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import '@features/Incentive/incentive.css';
import { DashboardSelector } from '../store/DashboardSelector';
import { useEffect, useMemo, useState } from 'react';
import {
  GetContainerDashboardByContainerId,
  GetContainerDashboardCriticalByContainerId,
} from '../business/DashboardBusiness';
import { ContainerSelector, GetAllContainer } from '@features/Container';
import { ContainerDashboardCriticalModel, ContainerDashboardModel } from 'common/models/DashboardModel';
import { InfoCircleOutlined } from '@ant-design/icons';
import Card from 'antd/es/card/Card';
export const ContainerDashboardCritical = () => {
  const dispatch = useDispatch();
  const dashboardState = useSelector(DashboardSelector);
  const containerState = useSelector(ContainerSelector);
  const data = useMemo(
    () => dashboardState.ContainerDashboardCriticalList || [],
    [dashboardState.ContainerDashboardCriticalList]
  );
  const [selectedContainer, setSelectedContainer] = useState<string | null>(null);
  const destinationOptions = Array.from(new Set(data.map((item) => item.Destination))).map((status) => ({
    text: status,
    value: status,
  }));
  const daysOptions = Array.from(new Set(data.map((item) => item.IsLessThanDaysLeft))).map((status) => ({
    text: status,
    value: status,
  }));
  const columns = [
    {
      title: 'Reference no.',
      dataIndex: 'RefNo',
      key: 'RefNo',
      render: (text, record) => (
        <span>
          {text}{' '}
          <Tooltip
            title={
              <>
                <div dangerouslySetInnerHTML={{ __html: record.Sender }}></div>
              </>
            }
          >
            <InfoCircleOutlined />
          </Tooltip>
        </span>
      ),
    },

    {
      title: 'Barcode no.',
      dataIndex: 'BarcodeNo',
      key: 'BarcodeNo',
    },

    {
      title: 'Destination',
      dataIndex: 'Province',
      key: 'Province',
      render: (text, record) => `${record.Province}, ${record.Location}`,
    },
    {
      title: 'Destination',
      dataIndex: 'Destination',
      key: 'Destination',
      filters: destinationOptions,
      onFilter: (value: string | number | boolean, record: ContainerDashboardCriticalModel) => {
        if (typeof value === 'string') {
          return record.Destination.includes(value);
        }
        return false;
      },
    },
    {
      title: 'ETA',
      dataIndex: 'ETA',
      key: 'ETA',
      render: (text, record) => {
        return record.ETA === null || record.IsWD === null ? '' : `${record.ETA} ${record.IsWD}`;
      },
    },
    {
      title: 'Estimated delivery date',
      dataIndex: 'EstimatedStartDate',
      key: 'EstimatedStartDate',
      sorter: (a, b) => a.EstimatedStartDate.localeCompare(b.EstimatedStartDate),
      render: (text, record) => {
        return record.EstimatedStartDate === '-' && record.EstimatedEndDate === '-'
          ? ''
          : `${record.EstimatedStartDate} to ${record.EstimatedEndDate}`;
      },
    },
    // {
    //   title: 'Delivered date',
    //   dataIndex: 'DeliveredDate',
    //   key: 'DeliveredDate',
    // },

    {
      title: 'Days delayed',
      dataIndex: 'DaysDelayed',
      key: 'DaysDelayed',

      render: (text) => (text === 0 ? '' : text),
      sorter: (a, b) => a.DaysDelayed - b.DaysDelayed,
    },
    // {
    //   title: 'Urgent (≤3 days left)',
    //   dataIndex: 'IsLessThanDaysLeft',
    //   key: 'IsLessThanDaysLeft',
    //   render: (text, record) => (record.DeliveredDate ? '' : text),
    // },
    // {
    //   title: 'Days before/on estimated delivery',
    //   dataIndex: 'DaysDeliveredBeforeEstimatedEndDate',
    //   key: 'DaysDeliveredBeforeEstimatedEndDate',
    //   render: (text) => (text === 0 ? '' : text),
    // },
  ];
  const [form] = Form.useForm();

  useEffect(() => {
    const fetchData1 = async () => {
      await dispatch(GetAllContainer());
    };

    fetchData1();
  }, [dispatch]);

  // Handle input change
  const handleContainerChange = async (event) => {
    setSelectedContainer(event);
    await dispatch(GetContainerDashboardCriticalByContainerId(event));
  };

  const [filterValue, setFilterValue] = useState(containerState.SelectedReferenceNo);
  const [filteredData, setFilteredData] = useState(data);

  // Handle input change
  const handleRefNoChange = (event) => {
    const value = event.target.value;
    setFilterValue(value);
  };

  const FunctionSearch = (text: string) => {
    if (!text) {
      setFilteredData(data);
      return;
    }

    // Filter data based on the search text
    const filtered = data.filter((item) =>
      Object.values(item).some((value) => String(value).toLowerCase().includes(text.toLowerCase()))
    );

    setFilteredData(filtered);
  };

  // Filter the data whenever filterValue or data changes
  useEffect(() => {
    if (filterValue) {
      FunctionSearch(filterValue.toLowerCase());
    } else {
      setFilteredData(data);
    }
    setFilterValue(filterValue);
  }, [filterValue, data]);
  return (
    <div className="App">
      <Card>
        <Row>
          <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            {containerState.ContainerList && containerState?.ContainerList?.length > 0 && (
              <>
                <Form.Item label="Select container no." name="Container">
                  <Select
                    size="large"
                    showSearch
                    placeholder="Select"
                    optionFilterProp="children"
                    onChange={handleContainerChange}
                  >
                    <Select key="" value=""></Select>
                    {containerState?.ContainerList?.map((destination) => (
                      <Select.Option key={destination.Id} value={destination.Id}>
                        {destination.ContainerNo}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </>
            )}
          </Col>
        </Row>
        {selectedContainer && (
          <>
            <Row>
              <Col xs={24} sm={20} md={12} lg={12} xl={12}>
                {/* <label>Warehouse-in: {dashboardState.ContainerDashboardCriticalList?.[0]?.StartDate ?? ''}</label> */}
                {dashboardState.ContainerDashboardList?.[0]?.StartDate && (
                  <>
                    <label>Warehouse-in: {dashboardState.ContainerDashboardCriticalList?.[0]?.StartDate ?? ''}</label>
                    <div>Number of box(es) loaded: {data?.length}</div>
                  </>
                )}
              </Col>
            </Row>
          </>
        )}
      </Card>
      <Card>
        {dashboardState.ContainerDashboardCriticalList?.[0]?.StartDate && (
          <>
            <>
              <Row>
                <Col xs={24} sm={16} md={8} lg={6} xl={5}>
                  <Form.Item label="" name="RefNo" initialValue={filterValue}>
                    <Input size="middle" maxLength={25} placeholder="Search.." onChange={handleRefNoChange} />
                  </Form.Item>
                </Col>
              </Row>
            </>
            <Table dataSource={filteredData} columns={columns} pagination={{ pageSize: 100 }} />
          </>
        )}
      </Card>
    </div>
  );
};
